import styled from 'styled-components';
import { device } from "../device";

const ChapterSpace = styled.div`
    height: 96px;

    @media ${device.lg} {
        height: 128px;
    }
`;

export default ChapterSpace;